import script from "./AIAssistantDeviceRecordingWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantDeviceRecordingWidget.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantDeviceRecordingWidget.vue?vue&type=style&index=0&id=29d1bf91&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d1bf91"]])

export default __exports__